import { adjustRange } from "../../helpers/formatData";
import { useDispatch, useSelector } from "react-redux";
import {
	setInterval,
	stockSelector,
} from "../../reducers/stocks/StockSlice";
import { Button, NavItem } from "reactstrap";
import "./index.css";
import { ReactElement } from "react";
import { NavTabs } from "./types";
import {
	twelveDataQuote,
	twelveDataTimeSeries,
} from "../../clients/twelveData";
import { calculateNetDiff } from "../../helpers/calculateNetDiff";

const GraphNavItem = (props: NavTabs): ReactElement => {
	const dispatch = useDispatch();
	const { TwelveDataStockTimeSeries, loading } = useSelector(stockSelector);
	const { range, setActive, isActive } = props;
	const { values } = TwelveDataStockTimeSeries;
	const first = parseFloat(values[values.length - 1].open);
	const latestPrice = parseFloat(values[0].open);
	const gainLoss = calculateNetDiff(latestPrice, first);
	const net = parseFloat(gainLoss);
	const changeRange = (e: React.MouseEvent<Element, MouseEvent>) => {
		if (isActive || loading) {
			return;
		}
		const target = e.target as HTMLElement;
		const range: string = target.innerText;
		let interval, outputSize;
		switch (range) {
			case "1D":
				interval = "1min";
				outputSize = "390";
				adjustRange(
					interval,
					outputSize,
					dispatch,
					setInterval,
					twelveDataTimeSeries,
					twelveDataQuote,
					TwelveDataStockTimeSeries.meta.symbol
				);
				setActive(0);
				break;

			case "5D":
				interval = "5min";
				outputSize = "390";
				adjustRange(
					interval,
					outputSize,
					dispatch,
					setInterval,
					twelveDataTimeSeries,
					twelveDataQuote,
					TwelveDataStockTimeSeries.meta.symbol
				);
				setActive(1);
				break;

			case "1M":
				interval = "1h";
				outputSize = "731";
				adjustRange(
					interval,
					outputSize,
					dispatch,
					setInterval,
					twelveDataTimeSeries,
					twelveDataQuote,
					TwelveDataStockTimeSeries.meta.symbol
				);
				setActive(2);
				break;

			case "3M":
				interval = "1h";
				outputSize = "2192";
				adjustRange(
					interval,
					outputSize,
					dispatch,
					setInterval,
					twelveDataTimeSeries,
					twelveDataQuote,
					TwelveDataStockTimeSeries.meta.symbol
				);
				setActive(3);
				break;

			case "1Y":
				interval = "1day";
				outputSize = "365";
				adjustRange(
					interval,
					outputSize,
					dispatch,
					setInterval,
					twelveDataTimeSeries,
					twelveDataQuote,
					TwelveDataStockTimeSeries.meta.symbol
				);
				setActive(4);
				break;
			default:
				break;
		}
	};
	return (
		<NavItem>
			<Button
				className={
					(isActive ? "active-" : "") + (net > 0 ? "bullish" : "bearish")
				}
				onClick={(e) => changeRange(e)}
				color={isActive ? "" : "link"}
				disabled={loading}
			>
				{range}
			</Button>
		</NavItem>
	);
};

export default GraphNavItem;
